import React, { Component } from 'react';
import { Textbox, Textarea } from 'react-inputs-validation';
import 'react-inputs-validation/lib/react-inputs-validation.min.css';
import Select2 from 'react-select2-wrapper';
import $ from "jquery";
import 'react-select2-wrapper/css/select2.css';
import { reactLocalStorage } from 'reactjs-localstorage';
import { LOGIN_TYPE_ADMIN } from "./helper/Constants";


import Apihelpers from './helper/ApiHelper';

class RcTransfer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fullName: '',
      contactNumber: '',
      email: '',
      aadharNumber: '',
      rcNumber: '',
      rtoLocation: 'Same RTO',
      fromCityTransfer: '',
      toCityTransfer: '',
      rcDoc: '',
      rcDocName: '',
      rcDocB: '',
      rcDocBName: '',
      veInsuDoc: '',
      veInsuDocName: '',
      aadharDoc: '',
      aadharDocName: '',
      aadharDocB: '',
      aadharDocBName: '',
      panDoc: '',
      panDocName: '',
      hasFullNameError: true,
      hasContactNumber: true,
      fromCityTransferError: false,
      toCityTransferError: false,
      hasEmail: true,
      hasAadhar: true,
      hasRcNumber: true,
      hasRcDoc: true,
      hasRcDocB: true,
      hasVeInsuDoc: false,
      hasAadharDoc: false,
      hasAadharDocB: false,
      hasPanDoc: false,
      currentRender: 0,
      loading: false,
      cityList: []
    };
  }

  toggleValidatingTabone(screenTwo) {
    this.setState({ screenTwo });
  }
  componentDidMount() {
    this.customeJquery();
    this.sendRequest();

  }
  sendRequest = async () => {
    /*await Apihelpers.getCityListRes('cities').then(
      res => {
        //console.log('res', res);
        if (res.data.status == 'sucess') {
          //console.log(res.data.data);
          this.setState({
            cityList: res.data.data
          });
          //console.log('cityList', this.state.cityList);
          //console.log('data ture');
        } else {
          console.log('false data');
        }
      },
    );*/
  }

  customeJquery() {
    $('#fromCityTransfer').select2({
      placeholder: "Search City",
      ajax: {
        url: Apihelpers.getBaseUrl() + 'cities/citiesList',
        processResults: function (res) {
          //console.log('res', res.data);
          return {
            results: res.data
          }
        }
      },
      "language": {
        "noResults": function () {
          return "Search here";
        }
      },
    });
    $('#toCityTransfer').select2({
      placeholder: "Search City",
      ajax: {
        url: Apihelpers.getBaseUrl() + 'cities/citiesList',
        processResults: function (res) {
          //console.log('res', res.data);
          return {
            results: res.data
          }
        }
      },
      "language": {
        "noResults": function () {
          return "Search here";
        }
      },
    });

    $('.mForm .input').focusout(function () {
      if ($(this).val() !== '') {
        $(this)
          .parents('.inputfield')
          .find('label')
          .addClass('active');
      } else {
        $(this)
          .parents('.inputfield')
          .find('label')
          .removeClass('active');
      }
    });
    $('.mForm .input').focus(function () {
      $(this)
        .parents('.inputfield')
        .find('label')
        .addClass('active');
    });
    $('.mForm input[name="rtoLocation"]').change(function () {
      if ($(this).val() !== 'Same State') {
        $('.toCity').hide();
      } else {
        $('.toCity').show();
      }
    });
  }

  submitScreenOne = () => {
    this.setState({
      currentRender: 1,
    });
  };
  submitScreenTwo = () => {
    if (this.state.fromCityTransfer === '') {
      this.setState({
        fromCityTransferError: true,
      });
    }
    if (this.state.rtoLocation === 'Same State') {
      if (this.state.toCityTransfer === '') {
        this.setState({
          toCityTransferError: true,
        });
      }
    } else {
      this.setState({
        toCityTransferError: false,
      });
    }
    this.toggleValidatingTabone(true);
    if (
      !this.state.hasFullNameError &&
      !this.state.hasContactNumber &&
      !this.state.hasEmail &&
      !this.state.hasAadhar &&
      !this.state.hasAadharB &&
      !this.state.hasRcNumber &&
      !this.state.fromCityTransferError &&
      !this.state.toCityTransferError
    ) {
      console.log('screen two is valid');
      this.setState({
        currentRender: 2,
      });
    } else {
      console.log('screen two not valid');
    }
    return;
  };
  toggleValidatingThree(screenThree) {
    this.setState({ screenThree });
  }
  submitScreenThree = e => {
    e.preventDefault();
    this.toggleValidatingThree(true);
    //console.log('hasRcDoc', this.state.hasRcDoc);
    //console.log('hasRcDocB', this.state.hasRcDocB);
    //console.log('hasVeInsuDoc', this.state.hasVeInsuDoc);
    //console.log('hasAadharDoc', this.state.hasAadharDoc);
    //console.log('hasAadharDocB', this.state.hasAadharDocB);
    //console.log('hasPanDoc', this.state.hasPanDoc);
    if (
      !this.state.hasRcDoc &&
      !this.state.hasRcDocB &&
      !this.state.hasVeInsuDoc &&
      !this.state.hasAadharDoc &&
      !this.state.hasAadharDocB &&
      !this.state.hasPanDoc
    ) {
      console.log('screen three is valid');
      const createRcTransferData = new FormData();
      createRcTransferData.append('fullName', this.state.fullName);
      createRcTransferData.append('contactNumber', this.state.contactNumber);
      createRcTransferData.append('email', this.state.email);
      createRcTransferData.append('aadharNumber', this.state.aadharNumber);
      createRcTransferData.append('rcNumber', this.state.rcNumber);
      createRcTransferData.append('rtoLocation', this.state.rtoLocation);
      createRcTransferData.append(
        'fromCityTransfer',
        this.state.fromCityTransfer,
      );
      createRcTransferData.append('toCityTransfer', this.state.toCityTransfer);
      createRcTransferData.append('rcDoc', this.state.rcDoc);
      createRcTransferData.append('rcDocB', this.state.rcDocB);
      createRcTransferData.append('veInsuDoc', this.state.veInsuDoc);
      createRcTransferData.append('aadharDoc', this.state.aadharDoc);
      createRcTransferData.append('aadharDocB', this.state.aadharDocB);
      createRcTransferData.append('panDoc', this.state.panDoc);
      //console.log('createRcTransferData', Array.from(createRcTransferData));
      this.setState({ loading: true });
      Apihelpers.postdatarctransfer('rctransfer', createRcTransferData).then(
        res => {
          console.log('res', res.data);
          if (res.data.status == true) {
            this.setState({ loading: false, currentRender: 3 });
          }
        },
      );
    } else {
      console.log('screen three not valid now');
    }
  };
  submitScreenFour = () => {
    window.location.href = reactLocalStorage.get("login_type") == LOGIN_TYPE_ADMIN ? "/admin/client-list" :"/admin/client-edit-view/"+reactLocalStorage.get("login_user_id");
    //window.location.href = "rc-transfer-thankyou";
  };
  handleFromCity = event => {
    this.setState({
      fromCityTransfer: event.target.value,
    });
    if (event.target.value !== '') {
      this.setState({
        fromCityTransferError: false,
      });
    }
  };
  handleToCity = event => {
    this.setState({
      toCityTransfer: event.target.value,
    });
    if (event.target.value !== '') {
      this.setState({
        toCityTransferError: false,
      });
    }
  };
  handleRtoLocatio = event => {
    this.setState({ rtoLocation: event.target.value });
  };
  backScreen = () => {
    window.location.href = "rc-transfer-thankyou";
  }
  render() {
    return (
      <React.Fragment>
        <div className="wrapper">
          <form
            className="mForm"
            method="post"
            encType="multipart/form-data"
            autoComplete="off"
          >
            <div
              className="mContainer"
              style={{
                display: `${this.state.currentRender == 0 ? 'block' : 'none'}`,
              }}
            >
              <div className="mTopB">
                <h3>
                  <span onClick={this.backScreen} className="backArrow">&nbsp;</span> RC Transfer
                </h3>
              </div>
              <div className="mMiddle">
                <div className="mRcTransfer">
                  <figure className="textF">
                    <img src="/assets/images/rc-transfer.svg" alt="" />
                  </figure>
                  <div className="textG">
                    RC Transfer made effortless!
                  </div>
                  <div className="textH">
                    Say goodbye to the tedious process of RC transfer. Our experts are always available to assist you, right from the comfort of your home.
                  </div>
                  <ul className="textI">
                    <li>Fill in the simple form with your vehicle details</li>
                    <li>Upload the necessary documents securely</li>
                    <li>Our team of experts will get in touch with you to assist you</li>
                  </ul>
                  <div className="submitRow">
                    <button
                      type="button"
                      className="yellowBtn"
                      onClick={this.submitScreenOne}
                    >
                      Continue
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div
              className="mContainer"
              style={{
                display: `${this.state.currentRender == 1 ? 'block' : 'none'}`,
              }}
            >
              <div className="mTop">
                <h3>
                  <span
                    className="backArrow"
                    onClick={() => this.setState({ currentRender: 0 })}
                  />{' '}
                  Fill The Respected Details
                </h3>
              </div>
              <div className="mMiddle">
                <div className="inputfield">
                  <Textbox
                    attributesInput={{
                      name: 'fullName',
                      type: 'text',
                      className: 'input',
                    }}
                    value={this.state.fullName}
                    validate={this.state.screenTwo} // Optional.[Bool].Default: false. If you have a submit button and trying to validate all the inputs of your form at onece, toggle it to true, then it will validate the field and pass the result via the "validationCallback" you provide.
                    validationCallback={res => {
                      this.setState({
                        hasFullNameError: res,
                        screenTwo: false,
                      });
                    }}
                    onChange={(fullName, e) => {
                      this.setState({ fullName });
                    }}
                    onBlur={e => {
                      console.log();
                    }}
                    validationOption={{
                      name: 'Full Name',
                      check: true,
                      required: true,
                      customFunc: name => {
                        const reg = /^[a-zA-Z\s]*$/;
                        if (reg.test(String(name))) {
                          if (name.length > 50) {
                            return 'Client Name Should 50 Char';
                          } else {
                            return true;
                          }
                        } else {
                          return 'Enter Valid Name';
                        }
                      },
                    }}
                  />
                  <label className="inputTitle">Full Name</label>
                </div>
                <div className="inputfield mobileNum">
                  <Textbox
                    attributesInput={{
                      id: 'contactNumber',
                      name: 'contactNumber',
                      type: 'tel',
                      className: 'input',
                      maxLength: '10',
                    }}
                    value={this.state.contactNumber}
                    validate={this.state.screenTwo}
                    validationCallback={res => {
                      this.setState({
                        hasContactNumber: res,
                        screenTwo: false,
                      });
                    }}
                    onChange={(contactNumber, e) => {
                      this.setState({ contactNumber });
                    }}
                    onBlur={e => {
                      console.log();
                    }}
                    validationOption={{
                      name: 'Contact Number',
                      check: true,
                      required: true,
                      customFunc: phone => {
                        const reg = /^\d{10}$/;
                        if (reg.test(String(phone))) {
                          return true;
                        } else {
                          return 'Enter Valid Contact Number';
                        }
                      },
                    }}
                  />
                  <label className="inputTitle">Contact Number</label>
                  <span className="number">+91 -</span>
                </div>
                <div className="inputfield">
                  <Textbox
                    attributesInput={{
                      name: 'email',
                      type: 'email',
                      className: 'input',
                    }}
                    value={this.state.email}
                    validate={this.state.screenTwo}
                    validationCallback={res => {
                      this.setState({
                        hasEmail: res,
                        screenTwo: false,
                      });
                    }}
                    onChange={(email, e) => {
                      this.setState({ email });
                    }}
                    onBlur={e => {
                      console.log();
                    }}
                    validationOption={{
                      name: 'Email',
                      check: true,
                      required: true,
                      customFunc: email => {
                        const reg = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
                        if (reg.test(String(email))) {
                          return true;
                        } else {
                          return 'Enter Valid E-Mail';
                        }
                      },
                    }}
                  />
                  <label className="inputTitle">Email</label>
                </div>
                <div className="inputfield">
                  <Textbox
                    attributesInput={{
                      name: 'aadharNumber',
                      type: 'tel',
                      className: 'input',
                      maxLength: '12',
                    }}
                    value={this.state.aadharNumber}
                    validate={this.state.screenTwo}
                    validationCallback={res => {
                      this.setState({
                        hasAadhar: res,
                        screenTwo: false,
                      });
                    }}
                    onChange={(aadharNumber, e) => {
                      this.setState({ aadharNumber });
                    }}
                    onBlur={e => {
                      console.log();
                    }}
                    validationOption={{
                      name: 'Aadhar Number',
                      check: true,
                      required: true,
                      customFunc: aadhar => {
                        const reg = /^\d{12}$/;
                        if (reg.test(String(aadhar))) {
                          return true;
                        } else {
                          return 'Enter Valid Aadhar Number';
                        }
                      },
                    }}
                  />
                  <label className="inputTitle">Aadhar Number</label>
                </div>
                <div className="inputfield">
                  <Textbox
                    attributesInput={{
                      name: 'rcNumber',
                      type: 'text',
                      className: 'input',
                      maxLength: '15',
                    }}
                    value={this.state.rcNumber}
                    validate={this.state.screenTwo}
                    validationCallback={res => {
                      this.setState({
                        hasRcNumber: res,
                        screenTwo: false,
                      });
                    }}
                    onChange={(rcNumber, e) => {
                      this.setState({ rcNumber });
                    }}
                    onBlur={e => {
                      console.log();
                    }}
                    validationOption={{
                      name: 'RC Number',
                      check: true,
                      required: true,
                      customFunc: rcNumber => {
                        //const reg = /^[A-Z]{2}[ -][0-9]{1,2}(?: [A-Z])?(?: [A-Z]*)? [0-9]{4}$/;
                        const reg = /[0-9a-zA-Z]{5,}/;
                        if (reg.test(String(rcNumber))) {
                          return true;
                        } else {
                          return 'Enter Valid RC Number';
                        }
                      },
                    }}
                  />
                  <label className="inputTitle">RC Number</label>
                </div>
                <div className="serviceBox">
                  <div className="radioGroup">
                    <label className="radioTitle">Type of service</label>
                    <div className="radioBtns">
                      <input
                        defaultChecked
                        id="sameRto"
                        type="radio"
                        name="rtoLocation"
                        value="Same RTO"
                        onChange={this.handleRtoLocatio}
                      />
                      <label htmlFor="sameRto">Same RTO</label>
                      <input
                        id="sameState"
                        type="radio"
                        name="rtoLocation"
                        value="Same State"
                        onChange={this.handleRtoLocatio}
                      />
                      <label htmlFor="sameState">Same State</label>
                    </div>
                  </div>
                  {/*<div className="inputfield">
                    <select
                      className="input"
                      name="fromCityTransfer"
                      value={this.state.fromCityTransfer}
                      onChange={this.handleFromCity}
                    >
                      <option value="">&nbsp;</option>
                      <option>from city 1</option>
                      <option>from city 2</option>
                      <option>from city 3</option>
                    </select>
                    <label className="inputTitle">
                      Transfer vehicle from which city
                    </label>
                  </div>*/}
                  <div className="inputfield">
                    <Select2
                      data={this.state.cityList}
                      options={{
                        placeholder: 'Search City',
                        required: true
                      }}
                      style={{
                        width: '100%',
                      }}
                      id="fromCityTransfer"
                      value={this.state.fromCityTransfer}
                      onChange={this.handleFromCity}
                      className="input"
                      name="fromCityTransfer"
                    />
                    <label className="inputTitle active">
                      Transfer vehicle from which city
                    </label>
                    <div className="cityError" style={{
                      display: `${this.state.fromCityTransferError ? 'block' : 'none'}`,
                    }}>
                      City cannot be empty
                    </div>
                  </div>
                  <div
                    className="inputfield toCity"
                    style={{ display: 'none' }}
                  >
                    <Select2
                      data={this.state.cityList}
                      options={{
                        placeholder: 'Search City',
                      }}
                      style={{
                        width: '100%',
                      }}
                      id="toCityTransfer"
                      value={this.state.toCityTransfer}
                      onChange={this.handleToCity}
                      className="input"
                      name="toCityTransfer"
                    />
                    <label className="inputTitle active">
                      Transfer vehicle to which city
                    </label>
                    <div className="cityError" style={{
                      display: `${this.state.toCityTransferError ? 'block' : 'none'}`,
                    }}>
                      City cannot be empty
                    </div>
                  </div>
                </div>
                <div className="submitRow">
                  <button
                    className="yellowBtn"
                    type="button"
                    onClick={this.submitScreenTwo}
                  >
                    Next
                  </button>
                </div>
              </div>
            </div>

            <div
              className="mContainer"
              style={{
                display: `${this.state.currentRender == 2 ? 'block' : 'none'}`,
              }}
            >
              <div className="mTop">
                <h3>
                  <span
                    className="backArrow"
                    onClick={() => this.setState({ currentRender: 1 })}
                  />{' '}
                  Upload Documents
                </h3>
              </div>
              <div className="mMiddle">
                <div className="textA">
                  Original document will help your RC Transfer quickly and
                  easier
                </div>
                <div className="inputfield">
                  <span className="inputFile">{this.state.rcDocName}</span>
                  <Textbox
                    attributesInput={{
                      id: 'rcDoc',
                      name: 'rcDoc',
                      type: 'file',
                      className: 'input',
                      accept: 'image/*,.doc, .docx,.pdf',
                    }}
                    //value={this.state.rcDoc}
                    disabled={false}
                    validate={this.state.screenThree}
                    validationCallback={res => {
                      this.setState({
                        hasRcDoc: res,
                        screenThree: false,
                      });
                    }}
                    onChange={(rcDoc, e) => {
                      let rcDocName = '';
                      if (e.target.files[0] !== undefined) {
                        rcDocName = e.target.files[0].name;
                      }
                      this.setState({
                        rcDoc: e.target.files[0],
                        rcDocName: rcDocName,
                      });
                    }}
                    onBlur={e => {
                      console.log();
                    }}
                    validationOption={{
                      name: 'Image',
                      check: true,
                      required: true,
                      customFunc: imagefile => {
                        var val = imagefile.toLowerCase(),
                          regex = new RegExp(
                            '(.*?).(jpg|jpeg|pdf|png|doc|docx)$',
                          );
                        var sizeInKB = this.state.rcDoc.size;
                        if (!regex.test(val)) {
                          $(this).val('');
                          return 'Enter Valid Image(jpg,jpeg,pdf,png,doc,docx)';
                        } else {
                          $(this).val('');
                          if (sizeInKB < 2000 || sizeInKB > 3000000) {
                            return 'Invalid Size(Size Should be 2KB to 3MB)';
                          } else {
                            return true;
                          }
                        }
                      },
                    }}
                  />
                  <label className="inputTitle">RC Card Front</label>
                </div>
                <div className="inputfield">
                  <span className="inputFile">{this.state.rcDocBName}</span>
                  <Textbox
                    attributesInput={{
                      id: 'rcDocB',
                      name: 'rcDocB',
                      type: 'file',
                      className: 'input',
                      accept: 'image/*,.doc, .docx,.pdf',
                    }}
                    //value={this.state.rcDocB}
                    disabled={false}
                    validate={this.state.screenThree}
                    validationCallback={res => {
                      this.setState({
                        hasRcDocB: res,
                        screenThree: false,
                      });
                    }}
                    onChange={(rcDocB, e) => {
                      let rcDocBName = '';
                      if (e.target.files[0] !== undefined) {
                        rcDocBName = e.target.files[0].name;
                      }
                      this.setState({
                        rcDocB: e.target.files[0],
                        rcDocBName: rcDocBName,
                      });
                    }}
                    onBlur={e => {
                      console.log();
                    }}
                    validationOption={{
                      name: 'Image',
                      check: true,
                      required: true,
                      customFunc: imagefile => {
                        //console.log('imagefile', imagefile);
                        var val = imagefile.toLowerCase(),
                          regex = new RegExp(
                            '(.*?).(jpg|jpeg|pdf|png|doc|docx)$',
                          );
                        var sizeInKB = this.state.rcDocB.size;
                        if (!regex.test(val)) {
                          $(this).val('');
                          return 'Enter Valid Image(jpg,jpeg,pdf,png,doc,docx)';
                        } else {
                          $(this).val('');
                          if (sizeInKB < 2000 || sizeInKB > 3000000) {
                            return 'Invalid Size(Size Should be 2KB to 3MB)';
                          } else {
                            return true;
                          }
                        }
                      },
                    }}
                  />
                  <label className="inputTitle">RC Card Back</label>
                </div>
                <div className="inputfield">
                  <span className="inputFile">{this.state.veInsuDocName}</span>
                  <Textbox
                    attributesInput={{
                      id: 'veInsuDoc',
                      name: 'veInsuDoc',
                      type: 'file',
                      className: 'input',
                      accept: 'image/*,.doc, .docx,.pdf',
                    }}
                    //value={this.state.rcDoc}
                    //validate={this.state.screenThree}
                    validationCallback={res => {
                      this.setState({
                        hasVeInsuDoc: res,
                      });
                    }}
                    onChange={(veInsuDoc, e) => {
                      let veInsuDocName = '';
                      if (e.target.files[0] !== undefined) {
                        veInsuDocName = e.target.files[0].name;
                      }
                      this.setState({
                        veInsuDoc: e.target.files[0],
                        veInsuDocName: veInsuDocName,
                      });
                    }}
                    onBlur={e => {
                      console.log();
                    }}
                    validationOption={{
                      name: 'Image',
                      required: false,
                      customFunc: imagefile => {
                        //console.log('imagefile', imagefile);
                        var val = imagefile.toLowerCase(),
                          regex = new RegExp(
                            '(.*?).(jpg|jpeg|pdf|png|doc|docx)$',
                          );
                        var sizeInKB = this.state.veInsuDoc.size;
                        if (!regex.test(val)) {
                          $(this).val('');
                          return 'Enter Valid Image(jpg,jpeg,pdf,png,doc,docx)';
                        } else {
                          $(this).val('');
                          if (sizeInKB < 2000 || sizeInKB > 3000000) {
                            return 'Invalid Size(Size Should be 2KB to 3MB)';
                          } else {
                            return true;
                          }
                        }
                      },
                    }}
                  />
                  <label className="inputTitle">Vehicle Insurance</label>
                </div>
                <div className="inputfield">
                  <span className="inputFile">{this.state.aadharDocName}</span>
                  <Textbox
                    attributesInput={{
                      name: 'aadharDoc',
                      type: 'file',
                      className: 'input',
                      accept: 'image/*,.doc, .docx,.pdf',
                    }}
                    validationCallback={res => {
                      this.setState({
                        hasAadharDoc: res,
                      });
                    }}
                    onChange={(aadharDoc, e) => {
                      let aadharDocName = '';
                      if (e.target.files[0] !== undefined) {
                        aadharDocName = e.target.files[0].name;
                      }
                      this.setState({
                        aadharDoc: e.target.files[0],
                        aadharDocName: aadharDocName,
                      });
                    }}
                    onBlur={e => {
                      console.log();
                    }}
                    validationOption={{
                      name: 'Image',
                      required: false,
                      customFunc: imagefile => {
                        //console.log('imagefile', imagefile);
                        var val = imagefile.toLowerCase(),
                          regex = new RegExp(
                            '(.*?).(jpg|jpeg|pdf|png|doc|docx)$',
                          );
                        var sizeInKB = this.state.aadharDoc.size;
                        if (!regex.test(val)) {
                          $(this).val('');
                          return 'Enter Valid Image(jpg,jpeg,pdf,png,doc,docx)';
                        } else {
                          $(this).val('');
                          if (sizeInKB < 2000 || sizeInKB > 3000000) {
                            return 'Invalid Size(Size Should be 2KB to 3MB)';
                          } else {
                            return true;
                          }
                        }
                      },
                    }}
                  />
                  <label className="inputTitle">Aadhar Card Front</label>
                </div>
                <div className="inputfield">
                  <span className="inputFile">{this.state.aadharDocBName}</span>
                  <Textbox
                    attributesInput={{
                      name: 'aadharDocB',
                      type: 'file',
                      className: 'input',
                      accept: 'image/*,.doc, .docx,.pdf',
                    }}
                    validationCallback={res => {
                      this.setState({
                        hasAadharDocB: res,
                      });
                    }}
                    onChange={(aadharDocB, e) => {
                      let aadharDocBName = '';
                      if (e.target.files[0] !== undefined) {
                        aadharDocBName = e.target.files[0].name;
                      }
                      this.setState({
                        aadharDocB: e.target.files[0],
                        aadharDocBName: aadharDocBName,
                      });
                    }}
                    onBlur={e => {
                      console.log();
                    }}
                    validationOption={{
                      name: 'Image',
                      required: false,
                      customFunc: imagefile => {
                        //console.log('imagefile', imagefile);
                        var val = imagefile.toLowerCase(),
                          regex = new RegExp(
                            '(.*?).(jpg|jpeg|pdf|png|doc|docx)$',
                          );
                        var sizeInKB = this.state.aadharDocB.size;
                        if (!regex.test(val)) {
                          $(this).val('');
                          return 'Enter Valid Image(jpg,jpeg,pdf,png,doc,docx)';
                        } else {
                          $(this).val('');
                          if (sizeInKB < 2000 || sizeInKB > 3000000) {
                            return 'Invalid Size(Size Should be 2KB to 3MB)';
                          } else {
                            return true;
                          }
                        }
                      },
                    }}
                  />
                  <label className="inputTitle">Aadhar Card Back</label>
                </div>
                <div className="inputfield">
                  <span className="inputFile">{this.state.panDocName}</span>
                  <Textbox
                    attributesInput={{
                      name: 'panDoc',
                      type: 'file',
                      className: 'input',
                      accept: 'image/*,.doc, .docx,.pdf',
                    }}
                    validationCallback={res => {
                      this.setState({
                        hasPanDoc: res,
                      });
                    }}
                    onChange={(panDoc, e) => {
                      let panDocName = '';
                      if (e.target.files[0] !== undefined) {
                        panDocName = e.target.files[0].name;
                      }
                      this.setState({
                        panDoc: e.target.files[0],
                        panDocName: panDocName,
                      });
                    }}
                    onBlur={e => {
                      console.log();
                    }}
                    validationOption={{
                      name: 'Image',
                      required: false,
                      customFunc: imagefile => {
                        //console.log('imagefile', imagefile);
                        var val = imagefile.toLowerCase(),
                          regex = new RegExp(
                            '(.*?).(jpg|jpeg|pdf|png|doc|docx)$',
                          );
                        var sizeInKB = this.state.panDoc.size;
                        if (!regex.test(val)) {
                          $(this).val('');
                          return 'Enter Valid Image(jpg,jpeg,pdf,png,doc,docx)';
                        } else {
                          $(this).val('');
                          if (sizeInKB < 2000 || sizeInKB > 3000000) {
                            return 'Invalid Size(Size Should be 2KB to 3MB)';
                          } else {
                            return true;
                          }
                        }
                      },
                    }}
                  />
                  <label className="inputTitle">Pan Card</label>
                </div>
                <div className="submitRow">
                  <button
                    className="yellowBtn"
                    type="button"
                    onClick={this.submitScreenThree}
                  >
                    Upload Documents{' '}
                    {this.state.loading == true ? 'loading...' : ''}
                  </button>
                </div>
                <div className="textB">
                  <strong>96% users</strong> who completed this stage, have
                  their RC transferred successfully
                </div>
              </div>
            </div>

            <div
              className="mContainer"
              style={{
                display: `${this.state.currentRender == 3 ? 'block' : 'none'}`,
              }}
            >
              <div className="mMiddle">
                <div className="thankYouBox">
                  <img src="/assets/images/thanks.svg" alt="" />
                  <div className="aa">Thank You Mr. {this.state.fullName}</div>
                  <div className="bb">Expert will reach you soon.</div>
                </div>
               {/* <div className="submitRow">
                  <button
                    className="yellowBtn"
                    type="button"
                    onClick={this.submitScreenFour}
                  >
                    Back to Home
                  </button>
                </div>*/}
              </div>
            </div>
          </form>
        </div>
      </React.Fragment>
    );
  }
}

export default RcTransfer;
